export enum ServicesTabs {
	all = 'all',
	favourites = 'favourites',
}
